/**
 * 新三板转板提示
 */
 import React, { useEffect, useState } from "react"
 import { getStockNoticeDetailData } from "../../../modules/quote/web"
 
 export function CommonNotice(props: { quotecode:string }) {
   const [noticeData,setNoticeData] = useState<any>([])
   const [noticeVisible, setNoticeVisible] = useState(true)
 
   useEffect(()=>{
     ;(async () => {
       let data = await getStockNoticeDetailData(props.quotecode)
       if (data) {
         setNoticeData(data[0])
       }
     })()
   },[])
 
   return (
     <>
       {noticeVisible && noticeData && noticeData.SECURITY_CODE && (
         <div className="comm-notice">
           <a href={`//wap.eastmoney.com/quote/stock/0.${noticeData.SECURITY_CODE}.html`}>公司于北交所转板上市，股票代码为 {noticeData.SECURITY_CODE}</a>
           <i className="comm-close" onClick={()=>setNoticeVisible(false)}/>
         </div>
       )}
     </>
   )
 }
 